import { usePublishRecordList } from '../hooks/useRecordList';
import type { EntityKind } from '../utils/entityRoutes';

/**
 * Renders nothing; publishes the ids a list is showing (in order) so the record
 * pages can step through them. A component rather than a hook call for list
 * screens that compute their rows inside a conditional branch, where a hook
 * cannot go.
 */
const RecordListPublisher = ({ kind, ids }: { kind: EntityKind; ids: ReadonlyArray<string | number | null | undefined> }): null => {
  usePublishRecordList(kind, ids);
  return null;
};

export default RecordListPublisher;
